import { combineReducers } from '@reduxjs/toolkit';
import { searchSlice } from './search/store/slice';

export const reportReducer = combineReducers({
  search: searchSlice.reducer,
});
